(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["featured-collection"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll('.show-hide-button').forEach(el => {
    el.addEventListener('click', (e) => {
      const isCollapsed = (el.dataset.collapsed === 'true');
      const mainContent = el.parentNode?.querySelector('.featured-collection-scroll-carousel-container');
      if (isCollapsed) {
        mainContent.classList.remove('hidden');
      } else {
        mainContent.classList.add('hidden');
      }
      el.dataset.collapsed = !isCollapsed;
    });
  });
});
  } catch(e) { console.error(e); }
})();

})();
